import { useMemo } from "react";
import { useGetShotsQuery } from "../app/services/shots";
import { isClientGroupPosition, isProducerGroupPosition } from "../utils/memberPositionUtils";

/**
 * プロジェクト内の ToDo ショット件数を返すフック。
 * BE の status フィルタを使い、ポジションに応じた対象ステータスだけを取得する。
 */
const useTodoCount = (
  projectId: string | undefined,
  position: string | undefined,
  skip = false,
): { count: number; isLoading: boolean } => {
  const statusFilter = useMemo(() => {
    if (!position) return undefined;
    if (isClientGroupPosition(position)) return "1,2,4";  // NEW, UPDATE, CLIENT_PENDING
    if (isProducerGroupPosition(position)) return "3";     // PRODUCER_PENDING
    return undefined;
  }, [position]);

  const { data: shotsData, isLoading } = useGetShotsQuery(
    { project_id: projectId || "", status: statusFilter },
    { skip: skip || !projectId || !position || !statusFilter },
  );

  const count = useMemo(() => {
    return shotsData?.data?.count ?? 0;
  }, [shotsData]);

  return { count, isLoading };
};

export default useTodoCount;
